export const SET_USER = 'github/setUser'
export const SET_REPOSITORIES = 'github/setRepositories'
export const SET_LOADING = 'github/setLoading'
export const SET_ERROR = 'github/setError'